import BaseModel from './base-model.js'
import { useSettings } from '@store/settings'
const $settings = useSettings()

class Category extends BaseModel {
    /**
     * Set the title of the model
     */
    title = 'Category'

    /**
     * Set the id of the model
     */
    route = 'category'

    /**
     * Primary key of the model
     *
     * @var {string}
     */
    primaryKey = 'category_id'
}

export default Category